import React, { useState, useEffect } from "react";
import FirstCardSection from "./First-Card-Section";

import RoomDetailsCard from "./Room-Details-Card";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";

const RightSectionPc = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.landlordslice);
  const token = user?.data?.accessToken;
  const id = user?.data?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [houseDetails, setHouseDetails] = useState([]);
  const [careTakerDetails, setCareTakerDetails] = useState([]);
  const [paymentProgressInvoices, setPaymentProgressInvoices] = useState([]);
  const [paymentProgressPayments, setPaymentProgressPayments] = useState([]);

  useEffect(() => {
    if (!id) return;
    dispatch(getProfile({ userId: id })).then((res) => {
      console.log("profile update", res);
      setProfileUpdated(true);
      setHouseDetails(res?.payload?.data?.tenant_details?.house_info);
      setCareTakerDetails(res?.payload?.data?.tenant_details?.caretaker);
      setPaymentProgressInvoices(
        res?.payload?.data?.tenant_details?.unpaidInvoices
      );
      setPaymentProgressPayments(
        res?.payload?.data?.tenant_details?.payments?.[0]
      );
    });
  }, [id]);

  return (
    <div style={{ width: "100%" }}>
    
      <div className="first-card-section" style={{ width: "100%" }}>
        
        <FirstCardSection
          paymentProgressInvoices={paymentProgressInvoices}
          paymentProgressPayments={paymentProgressPayments}
        />
        <RoomDetailsCard
          houseDetails={houseDetails}
          careTakerDetails={careTakerDetails}
        />
      </div>
    </div>
  );
};

export default RightSectionPc;
